/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Role_In_UseInputs */

const en_error_role_in_use = /** @type {(inputs: Error_Role_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The role is still in use: a user holds it, an approval gate is decided by it or an invitation offers it.`)
};

/**
* | output |
* | --- |
* | "The role is still in use: a user holds it, an approval gate is decided by it or an invitation offers it." |
*
* @param {Error_Role_In_UseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_role_in_use = /** @type {((inputs?: Error_Role_In_UseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Role_In_UseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_role_in_use(inputs)
});